const getCurrentPanel = (state: AnyFixMe) => state.googleMap.panel;
const getLocationIndex = (state: AnyFixMe) => state.googleMap.locationIndex;
const getOldLocationsForSession = (state: AnyFixMe, compId: AnyFixMe) =>
  state.googleMap[compId];

export { getCurrentPanel, getLocationIndex, getOldLocationsForSession };
